import * as React from 'react'

const useSessionStorage = <T>(key: string, initialValue: T ) : [storedValue: T, value: (value: T) => void] =>  {
    const [storedValue, setStoredValue] = React.useState(() => {
      try {
        const item = window.sessionStorage.getItem(key);
        return item ? JSON.parse(item) : initialValue;
      } catch (error) {
        console.log(error);
        return initialValue;
      }
    });
    const setValue = (value: T) => {
      try {
        const valueToStore =
          value instanceof Function ? value(storedValue) : value;
        setStoredValue(valueToStore);
        window.sessionStorage.setItem(key, JSON.stringify(valueToStore));
      } catch (error) {
        console.log(error);
      }
    };
    return [storedValue, setValue];
  }

  export default useSessionStorage